exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msgDio[data-v-1a5867df] .el-dialog__header{border-bottom:0}.msgDio div[data-v-1a5867df]{text-align:center;line-height:30px}\n", ""]);

// exports
